import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TDeleteFinixCardRequestSchema } from "./deleteFinixcard.schema";

export const deleteFinixCard =
  (axios: IAxiosInstance) => async (body: TDeleteFinixCardRequestSchema) => {
    const response = await axios.noRetry.delete(
      "/api/business-cards/finix-card",
      {
        data: body,
      }
    );
    const resData = response.data;
    if (resData.success) {
      return resData.data;
    }
    throw new Error("Error deleting Finix card");
  };
